import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/components/base/base.component';
import { AlertService } from 'src/app/core/services/alert.service';
import { BaseService } from 'src/app/core/services/base.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { ApiObjectData } from 'src/app/core/models/api-object-data';
// import { UserPackageService } from '../../core/services/userPackage.service';
// import { UserPackage } from './../../core/models/userPackage';
import { BehaviorSubject } from 'rxjs';
// import { User } from 'src/app/core/models/user';
import { Title } from '@angular/platform-browser';
// import { PackageService } from 'src/app/core/services/package.service';
// import { Package } from 'src/app/core/models/package';

@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.scss']
})
export class PaymentResultComponent extends BaseComponent implements OnInit {

  payment: any;
  done: boolean;
  tokenValid = false;
  endDate: string;
  constructor(
    public baseService: BaseService,
    private alertService: AlertService,
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private titleService: Title,
  ) { super() }

  ngOnInit(): void {
    const token = localStorage.getItem('token');
    if (token) { this.tokenValid = true; }
    else { this.tokenValid = false; }

    this.loadData();
  }

  loadData() {
    this.route.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      params => {
        if (params.id != null) {
          this.paymentService.get(params.id).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            (apiData: any) => {
              this.payment = apiData.result.returnData as any;
              this.done = this.payment.isDone;
              if (this.done === true) {
                
              }
            }
          )
        }
      }
    )
  }

}
